import { render, staticRenderFns } from "./ClientScopeSave.vue?vue&type=template&id=705c24b2&scoped=true&"
import script from "./ClientScopeSave.vue?vue&type=script&lang=ts&"
export * from "./ClientScopeSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c24b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705c24b2')) {
      api.createRecord('705c24b2', component.options)
    } else {
      api.reload('705c24b2', component.options)
    }
    module.hot.accept("./ClientScopeSave.vue?vue&type=template&id=705c24b2&scoped=true&", function () {
      api.rerender('705c24b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientScope/ClientScopeSave.vue"
export default component.exports